import { isNativeApp } from 'shared/javascripts/util/detection'

up.on('up:link:follow', '[data-confirm-dialog]', (event, element: HTMLElement) => {
  const message = element.getAttribute('data-confirm-dialog')!
  const layerOptions: Record<string, string> = {}

  const content = `
    <h3 class="confirm-dialog--title">${up.util.escapeHTML(message)}</h3>
    <div class="confirm-dialog--actions">
      <a href class="btn btn-primary me-3" up-accept>Ok</a>
      <a href class="btn btn-outline-primary" up-dismiss>Abbrechen</a>
    </div>
  `

  if (isNativeApp()) {
    layerOptions.class = 'native-confirm-dialog'
  }

  event.preventDefault()

  function onAccept(): void {
    up.render(event.renderOptions)
  }

  function onDismiss(): void {
    // up:link:follow was aborted
  }

  up.layer.ask({ content, ...layerOptions }).then(onAccept, onDismiss)
})
